__webpack_require__.p = "http://dashboard.enlacejuridicoacademico.com/";